export enum SupportedLanguages {
	DE = 'de',
	EN = 'en',
	RO = 'ro'
}

export const DEFAULT_LANGUAGE: SupportedLanguages = SupportedLanguages.RO;
